export interface SearchConsoleQueryRow {
  query: string;
  clicks: number;
  impressions: number;
  ctr: number;
  position: number;
}

function parseCsvRecords(input: string): string[][] {
  const records: string[][] = [];
  let record: string[] = [];
  let field = '';
  let quoted = false;
  const csv = input.replace(/^\uFEFF/, '');

  for (let i = 0; i < csv.length; i += 1) {
    const char = csv[i];
    if (char === '"') {
      if (quoted && csv[i + 1] === '"') {
        field += '"';
        i += 1;
      } else {
        quoted = !quoted;
      }
    } else if (char === ',' && !quoted) {
      record.push(field.trim());
      field = '';
    } else if ((char === '\n' || char === '\r') && !quoted) {
      if (char === '\r' && csv[i + 1] === '\n') i += 1;
      record.push(field.trim());
      if (record.some(Boolean)) records.push(record);
      record = [];
      field = '';
    } else {
      field += char;
    }
  }
  if (quoted) throw new Error('CSV has an unfinished quoted value.');
  record.push(field.trim());
  if (record.some(Boolean)) records.push(record);
  return records;
}

export function parseSearchConsoleCsv(input: string): SearchConsoleQueryRow[] {
  const records = parseCsvRecords(input);
  if (records.length < 2) throw new Error('The CSV has no query rows.');
  const headers = records[0].map((value) => value.toLowerCase().replace(/\s+/g, ' '));
  const column = (names: string[]) => headers.findIndex((header) => names.includes(header));
  const queryIndex = column(['top queries', 'query', 'queries']);
  const clicksIndex = column(['clicks']);
  const impressionsIndex = column(['impressions']);
  const ctrIndex = column(['ctr']);
  const positionIndex = column(['position']);
  if ([queryIndex, clicksIndex, impressionsIndex, ctrIndex, positionIndex].some((index) => index < 0)) {
    throw new Error('Use the Queries CSV exported from Search Console with query, clicks, impressions, CTR, and position columns.');
  }

  const number = (value: string) => Number(value.replace(/,/g, '').replace(/%/g, '').trim());
  const rows = records.slice(1).filter((record) => record[queryIndex]?.trim()).map((record) => {
    const rawCtr = record[ctrIndex] || '';
    const ctrValue = number(rawCtr);
    const row = {
      query: record[queryIndex].trim(),
      clicks: number(record[clicksIndex] || ''),
      impressions: number(record[impressionsIndex] || ''),
      ctr: rawCtr.includes('%') ? ctrValue / 100 : ctrValue > 1 ? ctrValue / 100 : ctrValue,
      position: number(record[positionIndex] || ''),
    };
    if (![row.clicks, row.impressions, row.ctr, row.position].every(Number.isFinite)) {
      throw new Error(`Invalid Search Console metrics for query: ${row.query}`);
    }
    return row;
  });
  if (!rows.length) throw new Error('The CSV has no query rows.');
  return rows;
}
